import { render, staticRenderFns } from "./gc-popup-sscc.vue?vue&type=template&id=c172cb7a"
import script from "./gc-popup-sscc.vue?vue&type=script&lang=js"
export * from "./gc-popup-sscc.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-sscc.vue?vue&type=style&index=0&id=c172cb7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports